// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZGF0YS1zdmc9ImNsb3NlIj48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNGNDkxMDMiIHN0cm9rZS13aWR0aD0iMi4wNiIgZD0iTTE2IDE2IDQgNE0xNiA0IDQgMTYiLz48L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[dir] .highlightSearchedWord--bZem5 {
  background-color: RGB(226, 226, 226);
}

.simplifiedSubjectPickerWrapper--rhQ5C {
  top: 0 !important;
}

[dir] .info-menu .simplifiedSubjectPickerWrapper--rhQ5C {
  transform: none;
}

@media (max-width: 768px) {
  .simplifiedSubjectPickerWrapper--rhQ5C {
    min-height: 100vh;
  }
  [dir] .simplifiedSubjectPickerWrapper--rhQ5C {
    padding-top: 100px;
  }
}

.subjectPickerWrapper--Gj5gH {
  position: absolute;
}

.simplifiedSubjectPickerWrapper--rhQ5C:before {
  display: none;
}

.quickSelectionWrapper--kKlEY {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: flex-end;
}

[dir] .quickSelectionWrapper--kKlEY {
  margin: 8px 0 20px 0;
}

[dir=ltr] .menuControlButton--rMrX5 {
  margin-right: 4px !important;
}

[dir=rtl] .menuControlButton--rMrX5 {
  margin-left: 4px !important;
}

.simplifiedViewDescription--o_DLr {
  width: 50%;
  display: inline-block;
}

.simplifiedViewSearchInput--T2a9s {
  width: 50%;
  display: inline-block;
}

[dir] .simplifiedViewSearchInput--T2a9s {
  text-align: end;
}

.measureTitle--cgfCi:hover {
  color: black !important;
  text-decoration: underline;
}

[dir] .measuresContainer--x4TM4 {
  border: 1px solid #c3c3c3;
  padding: 8px;
  margin-top: 8px;
}

[dir] .measureGroup--m_KCe {
  margin-bottom: 8px;
  border: 1px solid #c3c3c3;
}

[dir] .measureGroup--m_KCe:last-child {
  margin-bottom: 0;
}

.measureCollapse--Sz0Du {
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
}

[dir] .measureCollapse--Sz0Du {
  padding: 8px 10px;
  background: #f5f5f5;
}

@media screen and (max-width: 767px) {
  .measureCollapse--Sz0Du {
    align-items: flex-start;
    -moz-column-gap: 5px;
         column-gap: 5px;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto auto auto;
  }
  [dir] .measureCollapse--Sz0Du {
    padding: 8px;
  }

  .measureCollapse--Sz0Du h5 {
    min-width: 0;
    width: 100%;
  }
}

.overallGovernanceBar--V7KFg {
  align-items: center;
  display: inline-flex;
  flex-wrap: nowrap;
}

[dir] .overallGovernanceBar--V7KFg {
  padding: 2px 5px;
  margin-bottom: 8px;
  background: white;
  border: 1px solid #c3c3c3;
}

[dir] .overallGovernanceBarSelected--k0WRf {
  background: rgba(var(--selected_color), 0.25);
  border: 1px solid rgb(var(--selected_color));
}

.measureCollapseSimple--Evp0f {
  justify-content: space-between;
}

.measureName--VDDCo {
  font-size: 16px !important;
  font-family: museo-sans;
  font-weight: 300 !important;
  position: relative;
  text-transform: uppercase;
}

[dir] .measureName--VDDCo {
  margin-bottom: 0;
  margin-top: 0 !important;
  padding: 0;
}

.measureName--VDDCo a {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

[dir] .measureName--VDDCo a {
  padding: 6px 10px;
}

.measureIcon--JTg37 {
  height: 25px;
  width: 25px;
}

[dir=ltr] .measureIcon--JTg37 {
  margin: 0 5px 0 0;
}

[dir=rtl] .measureIcon--JTg37 {
  margin: 0 0 0 5px;
}

.appMenuList--xqsUA {
  list-style: none;
}

[dir] .appMenuList--xqsUA {
  margin-bottom: 0;
  background-repeat: no-repeat;
  background-size: 20px 20px;
}

[dir=ltr] .appMenuList--xqsUA {
  padding-left: 40px;
  background-position: 10px 4px;
}

[dir=rtl] .appMenuList--xqsUA {
  padding-right: 40px;
  background-position: right 10px top 4px;
}

[dir] .appMenuIntro--ZwK7F {
  margin-bottom: 20px;
}

[dir=ltr] .appMenuIntro--ZwK7F {
  padding-left: 45px;
}

[dir=rtl] .appMenuIntro--ZwK7F {
  padding-right: 45px;
}

.informationIcon--yq3gJ {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}

[dir] .informationIcon--yq3gJ {
  cursor: pointer;
}

[dir=ltr] .informationIcon--yq3gJ {
  margin-left: 6px;
}

[dir=rtl] .informationIcon--yq3gJ {
  margin-right: 6px;
}

.subCategoryList--OpWOC {
  position: relative;
}

.externalList--dp1SZ {
  position: relative;
  width: 100%;
  -moz-column-count: 1;
       column-count: 1;
  @media (min-width: 768px) {
    -moz-column-count: 2;
         column-count: 2;
  }
  @media (min-width: 1024px) {
    -moz-column-count: 3;
         column-count: 3;
  }
}

[dir=ltr] .externalList--dp1SZ {
  padding-right: 30px
}

[dir=rtl] .externalList--dp1SZ {
  padding-left: 30px
}

.externalName--b4da0 {
  font-family: museo-sans;
}

[dir] .externalName--b4da0 {
  margin-bottom: 0;
  padding: 4px 5px;
}

.listIcon--ZDnYg {
  position: absolute;
  top: 4px;
  width: 20px;
  height: 20px;
}

[dir=ltr] .listIcon--ZDnYg {
  left: 10px;
}

[dir=rtl] .listIcon--ZDnYg {
  right: 10px;
}

.subjectName--ZC0Yt {
  color: #000 !important;
  font-family: museo-sans;
  font-size: 16px;
  font-weight: 300;
  font-style: italic;
}

[dir] .subjectName--ZC0Yt {
  cursor: pointer;
}

.subjectNameLevel2--Hp1LZ {
  font-style: normal;
  color: #000 !important;
  font-size: 16px;
}

[dir] .subjectNameLevel2--Hp1LZ {
  padding: 3px 5px;
}

.level0--lJReE {
  font-size: 16px;
}

.level2--om9YG {
  position: relative;
  font-style: normal;
}

[dir] .level2--om9YG {
  margin-bottom: 5px;
}

.appMenuLevel3Expand--UobOW,
.appMenuLevel4Expand--NB_ZF {
  position: absolute;
  top: 5px;
}

[dir] .appMenuLevel3Expand--UobOW, [dir] .appMenuLevel4Expand--NB_ZF {
  margin: 0;
}

[dir=ltr] .appMenuLevel3Expand--UobOW, [dir=ltr] .appMenuLevel4Expand--NB_ZF {
  right: 0;
}

[dir=rtl] .appMenuLevel3Expand--UobOW, [dir=rtl] .appMenuLevel4Expand--NB_ZF {
  left: 0;
}

.subIndicatorsList--Gdyjs {
  list-style: none;
  position: relative;
}

[dir] .subIndicatorsList--Gdyjs {
  background-color: transparent;
}

.subSubIndicatorsList--QwIof {
  list-style: none;
  position: relative;
}

[dir] .subSubIndicatorsList--QwIof {
  background-color: transparent;
}

[dir=ltr] .subSubIndicatorsList--QwIof {
  padding-left: 20px;
  margin-left: -20px;
  margin-right: -20px;
}

[dir=rtl] .subSubIndicatorsList--QwIof {
  padding-right: 20px;
  margin-right: -20px;
  margin-left: -20px;
}

.citVoiceSubIndicatorsList--NYKNf {
  list-style: none;
  position: relative;
}

[dir] .citVoiceSubIndicatorsList--NYKNf {
  background-color: #fff;
}

.citVoiceList--yjGV4 {
  list-style: none;
}

[dir] .citVoiceList--yjGV4 {
  background-position-x: 12px;
  background-position-y: 24px;
  margin: 10px;
  padding: 20px 0;
  background-repeat: no-repeat;
  background-size: 20px 20px;
}

.expandIcon--foluf {
  stroke-width: 1px;
  stroke: #000;
  min-width: 17px;
}

[dir] .expandIcon--foluf {
  cursor: pointer;
}

[dir] .selected--ddwew {
  background: rgba(var(--selected_color), 0.25);
  border: 1px solid rgb(var(--selected_color));
}

[dir] .selectedGovernance--ZKmtL {
  cursor: pointer;
}

.selectedAll--s7z_Z {
  color: #000;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  position: relative;
  font-family: museo-sans;
  font-size: 16px;
}

[dir] .selectedAll--s7z_Z {
  background: hsla(0, 0%, 89%, 0.25);
  border: 1px solid #e2e2e2;
  border-radius: 5px;
  padding: 3px 5px !important;
}

.deselectX--Ow7lR {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  opacity: 0.6;
  flex-shrink: 0;
}

[dir] .deselectX--Ow7lR {
  cursor: pointer;
}

.deselectX--Ow7lR:hover {
  opacity: 1;
}

.deselectX--Ow7lR svg {
  width: 12px;
  height: 12px;
}

@media screen and (max-width: 767px) {
  .selected--ddwew,
  .selectedAll--s7z_Z {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .deselectX--Ow7lR {
    display: none;
  }
}

.externalItem--WeKlX a {
  display: inline-block;
}

[dir] .externalItem--WeKlX a {
  border: 1px solid rgba(255, 255, 255, 0);
}

[dir=ltr] .externalItem--WeKlX a {
  padding: 3px 25px 3px 5px;
}

[dir=rtl] .externalItem--WeKlX a {
  padding: 3px 5px 3px 25px;
}

.selectedExternal--hdfB4 a {
  font-weight: 700;
  position: relative;
  font-family: museo-sans;
}

[dir] .selectedExternal--hdfB4 a {
  border-radius: 5px;
  background-color: rgba(161, 159, 163, 0.25);
  border: 1px solid rgb(161, 159, 163);
}

[dir=ltr] .selectedExternal--hdfB4 a {
  padding: 3px 25px 3px 5px;
}

[dir=rtl] .selectedExternal--hdfB4 a {
  padding: 3px 5px 3px 25px;
}

.selectedExternal--hdfB4 a:after {
  content: ' ';
  height: 20px;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  position: absolute;
  top: calc(50% - 10px);
  width: 20px;
}

[dir] .selectedExternal--hdfB4 a:after {
  background: rgba(52, 60, 66, 0.5);
  background-repeat: no-repeat;
  background-size: contain;
}

[dir=ltr] .selectedExternal--hdfB4 a:after {
  right: 3px;
}

[dir=rtl] .selectedExternal--hdfB4 a:after {
  left: 3px;
}

.hidden--xkdlb {
  display: none !important;
}

.visibleMedium--hwTfL {
  display: none;
}

@media (min-width: 768px) {
  .visibleMedium--hwTfL {
    display: flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/js/components/SubjectPickerMenu/styles.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IAEE,iBAAiB;EACnB;EAHA;IACE,kBAAkB;EAEpB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,qBAAqB;AAEvB;;AANA;EAKE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAFA;EACE,2BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,qBAAqB;AAEvB;;AAJA;EAGE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,2BAA2B;AAG7B;;AAPA;EAKE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;IACvB,oBAAe;SAAf,eAAe;IACf,aAAa;IACb,oDAAoD;EAEtD;EANA;IAKE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AAKnB;;AARA;EAIE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAG3B,kBAAkB;EAClB,yBAAyB;AAE3B;;AATA;EAIE,gBAAgB;EAChB,wBAAwB;EAGxB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AAEV;;AALA;EAIE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EAEZ,WAAW;AACb;;AAJA;EAEE,iBAAiB;AAEnB;;AAJA;EAEE,iBAAiB;AAEnB;;AAEA;EACE,gBAAgB;AAMlB;;AAPA;EAGE,gBAAgB;EAChB,4BAA4B;EAC5B,0BAA0B;AAE5B;;AAPA;EAEE,kBAAkB;EAIlB,6BAA6B;AAC/B;;AAPA;EAEE,mBAAkB;EAIlB,uCAA6B;AAC/B;;AAEA;EAEE,mBAAmB;AACrB;;AAHA;EACE,kBAAkB;AAEpB;;AAHA;EACE,mBAAkB;AAEpB;;AAEA;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AANA;EAEE,eAAe;AAIjB;;AANA;EACE,gBAAgB;AAKlB;;AANA;EACE,iBAAgB;AAKlB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAElB,WAAW;EACX,oBAAe;OAAf,eAAe;EACf;IACE,oBAAe;SAAf,eAAe;EACjB;EACA;IACE,oBAAe;SAAf,eAAe;EACjB;AACF;;AAXA;EAEE;AASF;;AAXA;EAEE;AASF;;AAEA;EAGE,uBAAuB;AACzB;;AAJA;EACE,gBAAgB;EAChB,gBAAgB;AAElB;;AAEA;EACE,kBAAkB;EAElB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AANA;EAEE,UAAU;AAIZ;;AANA;EAEE,WAAU;AAIZ;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAEhB,kBAAkB;AACpB;;AAPA;EAKE,eAAe;AAEjB;;AAEA;EACE,kBAAkB;EAElB,sBAAsB;EACtB,eAAe;AACjB;;AALA;EAEE,gBAAgB;AAGlB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAElB,kBAAkB;AACpB;;AAJA;EAEE,kBAAkB;AAEpB;;AAEA;;EAGE,kBAAkB;EAElB,QAAQ;AACV;;AANA;EAEE,SAAS;AAIX;;AANA;EAIE,QAAQ;AAEV;;AANA;EAIE,OAAQ;AAEV;;AAEA;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAJA;EACE,6BAA6B;AAG/B;;AAEA;EAEE,gBAAgB;EAChB,kBAAkB;AAIpB;;AAPA;EACE,6BAA6B;AAM/B;;AAPA;EAIE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAPA;EAIE,mBAAkB;EAClB,mBAAkB;EAClB,kBAAmB;AACrB;;AAEA;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAJA;EACE,sBAAsB;AAGxB;;AAEA;EAOE,gBAAgB;AAClB;;AARA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,0BAA0B;AAE5B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EAEZ,eAAe;AACjB;;AALA;EAGE,eAAe;AAEjB;;AAEA;EACE,6CAA6C;EAC7C,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EAIX,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EAER,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAbA;EAEE,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;EAKlB,2BAA2B;AAI7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EAEZ,YAAY;EACZ,cAAc;AAChB;;AATA;EAME,eAAe;AAGjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;;IAEE,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,qBAAqB;AAGvB;;AAJA;EAGE,wCAAwC;AAC1C;;AAJA;EAEE,yBAAyB;AAE3B;;AAJA;EAEE,yBAAyB;AAE3B;;AAEA;EAEE,gBAAgB;EAEhB,kBAAkB;EAClB,uBAAuB;AAGzB;;AARA;EACE,kBAAkB;EAKlB,2CAA2C;EAC3C,oCAAoC;AACtC;;AARA;EAGE,yBAAyB;AAK3B;;AARA;EAGE,yBAAyB;AAK3B;;AAEA;EAIE,YAAY;EACZ,YAAY;EACZ,qDAA+Q;EAC/Q,6CAAuQ;EACvQ,kBAAkB;EAElB,qBAAqB;EACrB,WAAW;AACb;;AAZA;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,wBAAwB;AAS1B;;AAZA;EASE,UAAU;AAGZ;;AAZA;EASE,SAAU;AAGZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".highlightSearchedWord {\n  background-color: RGB(226, 226, 226);\n}\n\n.simplifiedSubjectPickerWrapper {\n  top: 0 !important;\n}\n\n:global(.info-menu) .simplifiedSubjectPickerWrapper {\n  transform: none;\n}\n\n@media (max-width: 768px) {\n  .simplifiedSubjectPickerWrapper {\n    padding-top: 100px;\n    min-height: 100vh;\n  }\n}\n\n.subjectPickerWrapper {\n  position: absolute;\n}\n\n.simplifiedSubjectPickerWrapper:before {\n  display: none;\n}\n\n.quickSelectionWrapper {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  align-items: flex-end;\n  margin: 8px 0 20px 0;\n}\n\n.menuControlButton {\n  margin-right: 4px !important;\n}\n\n.simplifiedViewDescription {\n  width: 50%;\n  display: inline-block;\n}\n\n.simplifiedViewSearchInput {\n  width: 50%;\n  display: inline-block;\n  text-align: end;\n}\n\n.measureTitle:hover {\n  color: black !important;\n  text-decoration: underline;\n}\n\n.measuresContainer {\n  border: 1px solid #c3c3c3;\n  padding: 8px;\n  margin-top: 8px;\n}\n\n.measureGroup {\n  margin-bottom: 8px;\n  border: 1px solid #c3c3c3;\n}\n\n.measureGroup:last-child {\n  margin-bottom: 0;\n}\n\n.measureCollapse {\n  align-items: center;\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  padding: 8px 10px;\n  background: #f5f5f5;\n}\n\n@media screen and (max-width: 767px) {\n  .measureCollapse {\n    align-items: flex-start;\n    column-gap: 5px;\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto auto auto;\n    padding: 8px;\n  }\n\n  .measureCollapse h5 {\n    min-width: 0;\n    width: 100%;\n  }\n}\n\n.overallGovernanceBar {\n  align-items: center;\n  display: inline-flex;\n  flex-wrap: nowrap;\n  padding: 2px 5px;\n  margin-bottom: 8px;\n  background: white;\n  border: 1px solid #c3c3c3;\n}\n\n.overallGovernanceBarSelected {\n  background: rgba(var(--selected_color), 0.25);\n  border: 1px solid rgb(var(--selected_color));\n}\n\n.measureCollapseSimple {\n  justify-content: space-between;\n}\n\n.measureName {\n  font-size: 16px !important;\n  font-family: museo-sans;\n  font-weight: 300 !important;\n  margin-bottom: 0;\n  margin-top: 0 !important;\n  position: relative;\n  text-transform: uppercase;\n  padding: 0;\n}\n\n.measureName a {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 6px 10px;\n}\n\n.measureIcon {\n  height: 25px;\n  margin: 0 5px 0 0;\n  width: 25px;\n}\n\n.appMenuList {\n  list-style: none;\n  padding-left: 40px;\n  margin-bottom: 0;\n  background-repeat: no-repeat;\n  background-size: 20px 20px;\n  background-position: 10px 4px;\n}\n\n.appMenuIntro {\n  padding-left: 45px;\n  margin-bottom: 20px;\n}\n\n.informationIcon {\n  margin-left: 6px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  vertical-align: middle;\n}\n\n.subCategoryList {\n  position: relative;\n}\n\n.externalList {\n  position: relative;\n  padding-right: 30px;\n  width: 100%;\n  column-count: 1;\n  @media (min-width: 768px) {\n    column-count: 2;\n  }\n  @media (min-width: 1024px) {\n    column-count: 3;\n  }\n}\n\n.externalName {\n  margin-bottom: 0;\n  padding: 4px 5px;\n  font-family: museo-sans;\n}\n\n.listIcon {\n  position: absolute;\n  left: 10px;\n  top: 4px;\n  width: 20px;\n  height: 20px;\n}\n\n.subjectName {\n  color: #000 !important;\n  font-family: museo-sans;\n  font-size: 16px;\n  font-weight: 300;\n  cursor: pointer;\n  font-style: italic;\n}\n\n.subjectNameLevel2 {\n  font-style: normal;\n  padding: 3px 5px;\n  color: #000 !important;\n  font-size: 16px;\n}\n\n.level0 {\n  font-size: 16px;\n}\n\n.level2 {\n  position: relative;\n  margin-bottom: 5px;\n  font-style: normal;\n}\n\n.appMenuLevel3Expand,\n.appMenuLevel4Expand {\n  margin: 0;\n  position: absolute;\n  right: 0;\n  top: 5px;\n}\n\n.subIndicatorsList {\n  background-color: transparent;\n  list-style: none;\n  position: relative;\n}\n\n.subSubIndicatorsList {\n  background-color: transparent;\n  list-style: none;\n  position: relative;\n  padding-left: 20px;\n  margin-left: -20px;\n  margin-right: -20px;\n}\n\n.citVoiceSubIndicatorsList {\n  background-color: #fff;\n  list-style: none;\n  position: relative;\n}\n\n.citVoiceList {\n  background-position-x: 12px;\n  background-position-y: 24px;\n  margin: 10px;\n  padding: 20px 0;\n  background-repeat: no-repeat;\n  background-size: 20px 20px;\n  list-style: none;\n}\n\n.expandIcon {\n  stroke-width: 1px;\n  stroke: #000;\n  cursor: pointer;\n  min-width: 17px;\n}\n\n.selected {\n  background: rgba(var(--selected_color), 0.25);\n  border: 1px solid rgb(var(--selected_color));\n}\n\n.selectedGovernance {\n  cursor: pointer;\n}\n\n.selectedAll {\n  color: #000;\n  background: hsla(0, 0%, 89%, 0.25);\n  border: 1px solid #e2e2e2;\n  border-radius: 5px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 5px !important;\n  position: relative;\n  font-family: museo-sans;\n  font-size: 16px;\n}\n\n.deselectX {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  opacity: 0.6;\n  flex-shrink: 0;\n}\n\n.deselectX:hover {\n  opacity: 1;\n}\n\n.deselectX svg {\n  width: 12px;\n  height: 12px;\n}\n\n@media screen and (max-width: 767px) {\n  .selected,\n  .selectedAll {\n    max-width: 200px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .deselectX {\n    display: none;\n  }\n}\n\n.externalItem a {\n  display: inline-block;\n  padding: 3px 25px 3px 5px;\n  border: 1px solid rgba(255, 255, 255, 0);\n}\n\n.selectedExternal a {\n  border-radius: 5px;\n  font-weight: 700;\n  padding: 3px 25px 3px 5px;\n  position: relative;\n  font-family: museo-sans;\n  background-color: rgba(161, 159, 163, 0.25);\n  border: 1px solid rgb(161, 159, 163);\n}\n\n.selectedExternal a:after {\n  background: rgba(52, 60, 66, 0.5);\n  background-repeat: no-repeat;\n  background-size: contain;\n  content: ' ';\n  height: 20px;\n  -webkit-mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZGF0YS1zdmc9ImNsb3NlIj48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNGNDkxMDMiIHN0cm9rZS13aWR0aD0iMi4wNiIgZD0iTTE2IDE2IDQgNE0xNiA0IDQgMTYiLz48L3N2Zz4=');\n  mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZGF0YS1zdmc9ImNsb3NlIj48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNGNDkxMDMiIHN0cm9rZS13aWR0aD0iMi4wNiIgZD0iTTE2IDE2IDQgNE0xNiA0IDQgMTYiLz48L3N2Zz4=');\n  position: absolute;\n  right: 3px;\n  top: calc(50% - 10px);\n  width: 20px;\n}\n\n.hidden {\n  display: none !important;\n}\n\n.visibleMedium {\n  display: none;\n}\n\n@media (min-width: 768px) {\n  .visibleMedium {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"highlightSearchedWord": `highlightSearchedWord--bZem5`,
	"simplifiedSubjectPickerWrapper": `simplifiedSubjectPickerWrapper--rhQ5C`,
	"subjectPickerWrapper": `subjectPickerWrapper--Gj5gH`,
	"quickSelectionWrapper": `quickSelectionWrapper--kKlEY`,
	"menuControlButton": `menuControlButton--rMrX5`,
	"simplifiedViewDescription": `simplifiedViewDescription--o_DLr`,
	"simplifiedViewSearchInput": `simplifiedViewSearchInput--T2a9s`,
	"measureTitle": `measureTitle--cgfCi`,
	"measuresContainer": `measuresContainer--x4TM4`,
	"measureGroup": `measureGroup--m_KCe`,
	"measureCollapse": `measureCollapse--Sz0Du`,
	"overallGovernanceBar": `overallGovernanceBar--V7KFg`,
	"overallGovernanceBarSelected": `overallGovernanceBarSelected--k0WRf`,
	"measureCollapseSimple": `measureCollapseSimple--Evp0f`,
	"measureName": `measureName--VDDCo`,
	"measureIcon": `measureIcon--JTg37`,
	"appMenuList": `appMenuList--xqsUA`,
	"appMenuIntro": `appMenuIntro--ZwK7F`,
	"informationIcon": `informationIcon--yq3gJ`,
	"subCategoryList": `subCategoryList--OpWOC`,
	"externalList": `externalList--dp1SZ`,
	"externalName": `externalName--b4da0`,
	"listIcon": `listIcon--ZDnYg`,
	"subjectName": `subjectName--ZC0Yt`,
	"subjectNameLevel2": `subjectNameLevel2--Hp1LZ`,
	"level0": `level0--lJReE`,
	"level2": `level2--om9YG`,
	"appMenuLevel3Expand": `appMenuLevel3Expand--UobOW`,
	"appMenuLevel4Expand": `appMenuLevel4Expand--NB_ZF`,
	"subIndicatorsList": `subIndicatorsList--Gdyjs`,
	"subSubIndicatorsList": `subSubIndicatorsList--QwIof`,
	"citVoiceSubIndicatorsList": `citVoiceSubIndicatorsList--NYKNf`,
	"citVoiceList": `citVoiceList--yjGV4`,
	"expandIcon": `expandIcon--foluf`,
	"selected": `selected--ddwew`,
	"selectedGovernance": `selectedGovernance--ZKmtL`,
	"selectedAll": `selectedAll--s7z_Z`,
	"deselectX": `deselectX--Ow7lR`,
	"externalItem": `externalItem--WeKlX`,
	"selectedExternal": `selectedExternal--hdfB4`,
	"hidden": `hidden--xkdlb`,
	"visibleMedium": `visibleMedium--hwTfL`
};
export default ___CSS_LOADER_EXPORT___;
